import apiWrapper from '../../services/apiWrapper';

export const updateChurches = async (churchData) => {
  try {
    // Ensure churchData is always an array, even if it's a single church object
    const churches = Array.isArray(churchData) ? churchData : [churchData];

    const response = await apiWrapper('put', '/admin/updatechurches', { churches });

    return {
      success: response.success,
      message: response.message,
    };
  } catch (error) {
    console.error('Error updating churches:', error);
    return {
      success: false,
      message: error.message || 'An error occurred while updating churches. Please try again later.',
    };
  }
};